var map = {
	"./aws.svg": 8509,
	"./bootstrap.svg": 9941,
	"./css.svg": 6934,
	"./digitalocean.svg": 1160,
	"./django.svg": 1819,
	"./figma.svg": 9839,
	"./git.svg": 1661,
	"./html.svg": 7225,
	"./javascript.svg": 2283,
	"./laravel.svg": 9396,
	"./materialui.svg": 4363,
	"./mongoDB.svg": 2302,
	"./mysql.svg": 6354,
	"./nextJS.svg": 491,
	"./nodejs.svg": 5967,
	"./postgresql.svg": 6467,
	"./python.svg": 7110,
	"./react.svg": 531,
	"./scss.svg": 7964,
	"./sqlite.svg": 23,
	"./tailwind.svg": 1107,
	"./typescript.svg": 2445,
	"./vitejs.svg": 5889,
	"./wordpress.svg": 8223
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8377;